export default {
  title: 'Dodaj plik: {{slot}}',
  replace_title: 'Zamień plik: {{slot}}',
  replace_description: 'Nowy plik zajmie miejsce tego dokumentu. Stary zachowujemy w naszych rejestrach.',
  form: {
    kind: {
      label: 'Rodzaj dokumentu tożsamości',
      options: {
        passport: 'Paszport',
        driver_license: 'Prawo jazdy',
        id_card: 'Dowód osobisty',
        residence_permit: 'Karta pobytu',
      },
    },
    front: {
      label: 'Przód',
    },
    back: {
      label: 'Tył',
    },
    file: {
      label: 'Plik',
    },
    expires_at: {
      label: 'Ważny do',
      placeholder: 'Wybierz datę',
    },
    holder: {
      label: 'Czyj to dokument?',
      options: {
        owner: 'Mój, właściciela',
        partner: 'Wspólnika',
      },
    },
    holder_name: {
      label: 'Imię i nazwisko wspólnika',
      placeholder: 'Imię i nazwisko',
    },
  },
  accepted_files: 'PDF, JPG lub PNG, do {{max}} MB.',
  accepted_images_min: 'Zdjęcie musi mieć co najmniej {{min}} KB.',
  errors: {
    file_type: 'Akceptowane są tylko pliki PDF, JPG lub PNG.',
    file_too_large: 'Plik jest większy niż {{max}} MB.',
    file_too_small: 'Zdjęcie musi mieć co najmniej {{min}} KB.',
  },
  buttons: {
    select_file: 'Wybierz plik',
    submit: 'Prześlij',
    cancel: 'Anuluj',
  },
  toasts: {
    success: 'Plik przesłany',
    error: 'Nie udało się przesłać pliku.',
  },
};
